<template>
    <modal :show.sync="show" modalClasses="medium-sized-modal" headerClasses="pb-0" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500">Edit Bank</h3>
        <b-form role="form" @submit.prevent="editProduct">
            <b-row>
                <b-col cols="6">
                    <b-form-group label="Bank">
                        <el-select v-model="form.bank_code" filterable placeholder="Select" @change="getBankerListHandler" v-loading="is_loading_bank" :disabled="cannotEdit">
                            <el-option
                            v-for="bank in banks"
                            :key="bank.bank_code"
                            :label="bank.bank_name"
                            :value="bank.bank_code"
                            >
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group label="Banker">
                        <el-select v-model="form.banker_id" filterable placeholder="Select Banker" v-loading="is_loading_bank" :disabled="cannotEdit" no-data-text="Banker Not Available">
                            <el-option
                            v-for="banker in bankers"
                            :key="banker.id"
                            :label="banker.name"
                            :value="banker.id"
                            >
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Loan Officer">
                        <el-select v-model="form.prod_loan_officer_id" clearable filterable placeholder="Select Loan Officer" :disabled="cannotEdit" @change="loanOfficerDetails">
                            <el-option
                            v-for="loan_officer in userLoanOfficerList"
                            :key="loan_officer.id"
                            :label="loan_officer.name"
                            :value="loan_officer.id"
                            >
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="SPA Price (RM)">
                        <b-form-input
                        v-model="form.spa_price"
                        type="text"
                        required
                        :disabled="cannotEdit"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Margin of Finance (%)">
                        <b-form-input
                        v-model="form.margin_finance"
                        type="text"
                        required
                        :disabled="cannotEdit"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Interest (%)">
                        <b-form-input
                        v-model="form.interest"
                        type="text"
                        required
                        :disabled="cannotEdit"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Tenure Year(s)">
                        <b-form-input
                        v-model="form.tenure_years"
                        type="text"
                        required
                        :disabled="cannotEdit"
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                
                <b-col cols="12" >
                    <b-form-group label="Additional Cost">
                        <b-form-input
                        v-model="form.prod_bnk_add_cost"
                        type="number"
                        step="0.01"
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <b-form-group label="Status">
                        <el-select v-model="form.bank_status" filterable placeholder="Select" :disabled="
                            !checkAccess(['p_product__manage']) && !auth_user.subscription.scrb_is_my_own"
                            @change="handleStatusChange(form.bank_status)"

                        >
                            <el-option
                            v-for="bank_status in bank_status_options"
                            :key="bank_status.value"
                            :label="bank_status.label"
                            :value="bank_status.value"
                            >
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Bank Submission Date">
                        <b-form-input
                        v-model="form.prod_bnk_submission_date"
                        type="date"
                        @change="onSubmissionDateChange"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12" v-if="isApprovedBank || (cannotEdit && form.approved_date)">
									<b-form-group label="Approved Date">
											<b-form-input
											v-model="form.approved_date"
											type="date"
											required
											:disabled="cannotEdit"
											></b-form-input>
									</b-form-group>
                </b-col>
                <b-col cols="6" class="mb-2">
                    <b-form-group label="Loan Amount" class="mb-2">
                        <b-form-input
                        v-model="form.loan_amount"
                        type="text"
                        step="0.01"
                        required
                        ></b-form-input>
                    </b-form-group>
                    <b-form-checkbox
                    class="text-muted"
                    v-model="is_override_loan_amount"
                    >
                    Override
                    </b-form-checkbox>
                </b-col>
                <b-col cols="6">
                    <p class="text-xs">Installment</p>
                    <h3 class="mb-0">RM{{ form.installment | moneyFormatter }}</h3>
                    <b-form-checkbox
                        class="text-muted"
                        v-model="is_override_installment"
                        >
                        Override
                        </b-form-checkbox>
                </b-col>
                <!-- <b-col cols="6">
                    <span class="text-xs">Other Expenses</span>
                    <el-tooltip effect="dark" placement="right-end">
                        <div slot="content">
                            <p class="text-white text-xs">Legal Fee: </p>
                            <p class="text-white text-xs">Insurance: </p>
                            <p class="text-white text-xs">Valuation Fee: </p>
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" class="cursor-pointer text-primary mx-2" width="12" height="12" viewBox="0 0 512 512"><path fill="currentColor" d="M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-40-176h24v-64h-24c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/></svg>
                    </el-tooltip>
                    
                    <h3>RM{{ otherExpenses | moneyFormatter }}</h3>
                </b-col> -->
                <b-col md="8" sm="12" class="mx-auto text-center mt-4 pt-2">
                    <b-button variant="primary" type="submit" class="w-100" :disabled="is_loading_btn">Save</b-button>
                </b-col>
            </b-row>
        </b-form>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Select, Option } from 'element-ui'
import { mapActions, mapState } from 'pinia'
import { usePMPStore } from '@/stores/pmpStore'
import { useProductStore } from '@/stores/productStore'
import { useCustomerStore } from '@/stores/customerStore'
import { useAccessControlStore } from '@/stores/accessControlStore'
import { axios, services, getHeader, notifyFunctionMixin, helperFunctionMixin } from '@/assets/js/httpImports.js'
import {
  calculateInstallment, 
  calculateLoanAmount,
} from '@/assets/js/calculator.js'
import { useAuthStore } from '@/stores/authStore'
import {BANK_CANNOT_EDIT_STATUS, BANK_APPROVAL_STATUS, BANK_STATUS} from '@/assets/js/status.js'
import {isEqual, cloneDeep} from 'lodash'
import caseEventBus from '@/assets/js/EventBus/caseEventBus.js'
import moment from 'moment'
import { useMessagingStore } from '@/stores/messagingStore'
import { useNotificationStore } from '@/stores/notificationStore'

export default {
    props:{
        show_edit_bank: Boolean,
        bank: Object,
        product: Object,
    },
    mixins: [notifyFunctionMixin, helperFunctionMixin],
    components: {
        Modal,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    data() {
        return {
            prodSSADetails: null, 
            is_override_loan_amount:true,
            form:{
                bank_code: '',
                bank_name: '',
                banker_id: '',
                spa_price: '',
                margin_finance: '',
                interest: '',
                tenure_years: '',
                approved_date: null,
                bank_status: '',
                installment: '',
                prod_bnk_submission_date: null,
                prod_loan_officer_id: '',
                loan_amount:'',
                prod_bnk_add_cost:'',
            },
            banks:[],
            dsr_bank: null,
            bankers: [],
            is_loading_btn: false,
            is_loading_bank: false,
            bank_status_options: BANK_STATUS,
            update_status_role_ids: [1],
            is_override_installment: false,
            selectedIds : [],
        }
    },
    computed: {
        ...mapState(useAuthStore, ['auth_user']),
        ...mapState(useAccessControlStore, ['userBankerList', 'userLoanOfficerList']),
        show: {
            get() {
                return this.show_edit_bank
            },
            set(newVal) {
                this.$emit('update:show_edit_bank', newVal)
            },
        },
        otherExpenses(){
            // let expenses = calculateInstallment(this.loanAmount, this.form.interest, this.form.tenure_years)
            return 0
        },
        cannotEdit(){
            return BANK_CANNOT_EDIT_STATUS.includes(this.bank.prod_bnk_stage_status) && !(this.checkAccess(['p_product__manage']))
        },
				isApprovedBank(){
					return BANK_APPROVAL_STATUS.indexOf(this.form.bank_status) !== -1;
				}
    },
    watch:{
        product:{
            async handler(newVal, oldVal){
				if(!isEqual(newVal, oldVal)){
                    await this.setProductDetail(newVal)
                }
                this.prodSSADetails = newVal.prod_ssa_detail;
            },
            immediate: true,
        },
        // 'form.bank_status': {
        //     handler(newStatus, oldStatus) {

        //         if (newStatus === 'Approved' && newStatus !== oldStatus) {
        //             const selectedSSA = this.prodSSADetails;
        //             if (selectedSSA) {
        //                 this.sendApprovalEmailToSSA(selectedSSA.name, selectedSSA.email);
        //             }
        //         }
        //     },
        //     immediate: false 
        // },
       'form.bank_status': {
            handler(newStatus, oldStatus) {
                if (newStatus === 'Approved' && newStatus !== oldStatus) {
                    this.sendApprovalEmail();
                } 
                else if (newStatus === 'Rejected' && newStatus !== oldStatus) {
                    this.sendRejectionEmail();
                } 
                else if (newStatus === 'Pending Approval' && newStatus !== oldStatus) {
                    this.sendPendingApprovalEmail();
                }
            },
            immediate: false,
        },

        bank:{
            async handler(newVal, oldVal){
                await this.setForm(newVal)
                await this.getBanks()
                await this.getBankerListHandler(cloneDeep(newVal.prod_bnk_code))
            },
            immediate: true,
        },
        'form.bank_code':{
            handler(newVal){
                this.setDSRBank()
            },
        },
        'form.spa_price':{
            handler(newVal){
                if(!this.is_override_loan_amount){
                    this.form.loan_amount = calculateLoanAmount(newVal, this.form.margin_finance)
                }
            },
            immediate: false,
        },
        'form.margin_finance':{
            handler(newVal){
                if(!this.is_override_loan_amount){
                    this.form.loan_amount = calculateLoanAmount(this.form.spa_price, newVal)
                }
            },
            immediate: false,
        },
        'form':{
            handler(newVal){
                if(!this.is_override_installment){
                    this.form.installment = calculateInstallment(newVal.loan_amount, newVal.interest, newVal.tenure_years)
                }
            },
            deep: true
        },
    },
    methods:{
        ...mapActions(usePMPStore, ['getPMPProjectBanks', 'syncV2CaseToPMP']),
        ...mapActions(useProductStore, ['addPropertyProductBank', 'updatePropertyProductBank', 'getBankersBasedOnBank', 'checkGenerateCommission', 'sendEmailToBanker']),
        ...mapActions(useMessagingStore, ['sendEmail', 'createGroupMessage', 'getNewBundleKey','setMessageProfile','getProfileBundleKey','generateMessageProfile']),
        ...mapActions(useNotificationStore, ['createNotification','fetchEmailTemplate', 'fetchNotificationTemplate']),
        async handleStatusChange(newStatus) {
            try {
                // Fetch the notification template using the trigger point 'LEAD_STATUS_CHANGE'
                const notificationTemplate = await this.fetchNotificationTemplate('CASE_STATUS_CHANGE');
                if (notificationTemplate && notificationTemplate.is_active) { 
                let message = notificationTemplate.notif_temp_message

                // Construct the notification content
                let contentNotification = {
                    noti_message: "Case #"+ this.product.prod_id +" : "+message+" "+newStatus,
                    noti_url: window.location.origin + '/casesListings',
                    microservice_code: 'product',
                    noti_related_type: 'product',
                    noti_related_id: this.product.prod_id,
                };

                // Get recipients from the template
                const recipients = notificationTemplate.notif_temp_receiver.split(',').map(id => parseInt(id.trim(), 10));

                for (const recipient of recipients) {
                          if (!isNaN(recipient)) { // Check if recipient is a valid integer
                            let notification = { ...contentNotification, noti_user_id: recipient };
                            
                            // let notification = { ...contentNotification, noti_user_id: recipients }

                            this.createNotification(notification)
                        }
                }   
              }

                this.notifySuccess('Notification sent successfully.');

            } catch (error) {
                console.error('Failed to send notification:', error);
                this.notifyError('Failed to send notification.');
            }
        },

        async sendEmailToLoanOfficer(loanOfficerName, loanOfficerEmail) {
                    const emailData = {
                        to: loanOfficerEmail, 
                        subject: `New Case Assigned: [ Property - ${this.product.prod_id} ]`,
                        body: `Dear ${loanOfficerName},\n\nA new case has been assigned to you. Please review the details at your earliest convenience.\n\nThank you,\nFintos Advice Consultancy Sdn Bhd`
                    };
                    try {
                        const response = await axios.post( services.product + 'send-email', emailData , {headers: getHeader()}); // Adjust the API endpoint as per your backend route
                        console.log('Email sent successfully:', response);
                    } catch (error) {
                        console.error('Error sending email:', error);
                    }
                },

                loanOfficerDetails() {
                    const selectedLoanOfficer = this.userLoanOfficerList.find(officer => officer.id === this.form.prod_loan_officer_id);
                    if (selectedLoanOfficer) {
                        this.sendEmailToLoanOfficer(selectedLoanOfficer.name ,  selectedLoanOfficer.email);
                    }
                },
                 async sendPendingApprovalEmail() {
                  try {
                    const emailTemplate = await this.fetchEmailTemplate('CASE_PENDING_APPROVAL');
                    if (emailTemplate && emailTemplate.is_active == 1) {

                      const recipients = emailTemplate.notif_temp_receiver.split(',').map(email => email.trim());

                      // Prepare the email data
                      const emailData = {
                        to: recipients, // Array of email addresses
                        subject: emailTemplate.notif_temp_title,
                        body: emailTemplate.notif_temp_message
                        .replace('{case_id}', this.product.prod_id) // Replace {case_id} with product ID
                        .replace('{case_name}', this.product.prod_customer_name), // Replace {case_name} with customer name
                      };
                      
                      await this.sendEmail(emailData);
                      this.notifySuccess('Pending Approval email sent successfully.');
                    }
                  } 
                  catch (error) {
                      console.error('Failed to send email:', error);
                      this.errorFunction(error);
                  }
                },
                async sendApprovalEmail() {
                  try {
                    const emailTemplate = await this.fetchEmailTemplate('CASE_APPROVE');
                    if (emailTemplate && emailTemplate.is_active == 1) {

                        const recipients = emailTemplate.notif_temp_receiver.split(',').map(email => email.trim());

                        // Prepare the email data
                        const emailData = {
                          to: recipients, // Array of email addresses
                          subject: emailTemplate.notif_temp_title,
                          body: emailTemplate.notif_temp_message
                          .replace('{case_id}', this.product.prod_id) // Replace {case_id} with product ID
                          .replace('{case_name}', this.product.prod_customer_name), // Replace {case_name} with customer name
                        };

                        await this.sendEmail(emailData);
                        this.notifySuccess('Approval email sent successfully.');
                      }
                    } 
                    catch (error) {
                        console.error('Failed to send email:', error);
                        this.errorFunction(error);
                    }
                  },
                async sendRejectionEmail() {
                  try {
                  const emailTemplate = await this.fetchEmailTemplate('CASE_REJECT');
                  if (emailTemplate && emailTemplate.is_active == 1) {

                  const recipients = emailTemplate.notif_temp_receiver.split(',').map(email => email.trim());

                  // Prepare the email data
                  const emailData = {
                    to: recipients, // Array of email addresses
                    subject: emailTemplate.notif_temp_title,
                    body: emailTemplate.notif_temp_message
                    .replace('{case_id}', this.product.prod_id) // Replace {case_id} with product ID
                    .replace('{case_name}', this.product.prod_customer_name), // Replace {case_name} with customer name
                  };

                      await this.sendEmail(emailData);
                      this.notifySuccess('Rejection email sent successfully.');
                    }
                  } 
                  catch (error) {
                      console.error('Failed to send email:', error);
                      this.errorFunction(error);
                  }
                },

                // async sendApprovalEmailToSSA(ssaName, ssaEmail) {
                //     const propertyId = this.product.prod_id;
                //     const emailData = {
                //         to: ssaEmail,
                //         subject: `Loan Approval Notification: [ Property - ${propertyId} ]`,
                //         body: `Dear ${ssaName},\n\nWe are pleased to inform you that the application for property ${propertyId} has been approved. Final approval details can be referred to in the system's last update.\n\nBest regards,\nFintos Advice Consultancy Sdn Bhd`
                //     };

                //     try {
                //         const response = await axios.post(services.product + 'send-email', emailData, { headers: getHeader() });
                //         console.log('Email sent successfully:', response);
                //     } catch (error) {
                //         console.error('Error sending email:', error);
                //     }
                // },
                async sendEmailToSSA(ssaName, ssaEmail) {
                    const emailData = {
                        to: ssaEmail, 
                        subject: `Application Update Processing with [ Property - ${this.product.prod_id} ]`,
                        body: `Dear ${ssaName},\n\nWe are pleased to inform that your client - ${this.product.prod_customer_name} application is currently being processed by ${this.form.bank_name} at ${this.form.prod_bnk_submission_date}.\n\nBest regards,\nFintos Advice Consultancy Sdn Bhd`
                    };

                    try {
                        const response = await axios.post(services.product + 'send-email', emailData , {headers: getHeader()});
                        console.log('Email sent successfully:', response);
                    } catch (error) {
                        console.error('Error sending email:', error);
                    }
                },

                async onSubmissionDateChange() {
                    const selectedSSA = this.prodSSADetails;
                    // console.log(selectedSSA.name, selectedSSA.email);
                    if (selectedSSA) {
                        this.sendEmailToSSA(selectedSSA.name, selectedSSA.email);
                    }
                },

        setDSRBank(){
            let dsr_bank = this.banks.find(bank => bank.bank_code == this.form.bank_code)
            if(dsr_bank){
                this.dsr_bank = dsr_bank
                this.form.interest = dsr_bank.bank_loan_interest_rate
                this.form.tenure_years = dsr_bank.bank_loan_tenure_year
            }else{
                this.form.interest = ''
                this.form.tenure_years = ''
            }
        },
        async setForm(data){
						this.form.bank_code = data.prod_bnk_code
            this.form.bank_name = data.prod_bnk_name
            this.form.banker_id = data.prod_bnk_banker_id
            this.form.spa_price = data.prod_bnk_spa_amount
            this.form.margin_finance = data.prod_bnk_margin
            this.form.interest = data.prod_bnk_interest
            this.form.tenure_years = data.prod_bnk_tenure
            this.form.bank_status = data.prod_bnk_stage_status
            this.form.installment = data.prod_bnk_installment
            this.form.loan_amount = data.prod_bnk_loan_amount
            this.is_override_installment = true
            this.form.prod_bnk_submission_date = data.prod_bnk_submission_date ? moment(data.prod_bnk_submission_date).format('YYYY-MM-DD') : ''
            this.form.prod_bnk_add_cost = data.prod_bnk_add_cost
            this.form.approved_date = data.prod_bnk_approved_date ? moment(data.prod_bnk_approved_date).format('YYYY-MM-DD') : ''
        },
        async setProductDetail(data){
            this.form.prod_loan_officer_id = data.prod_loan_officer_id
        },
        async getBanks(){
            this.is_loading_bank = true
            axios.get(services.customer + 'customer/' + this.product.prod_customer_id +'/dsr.eligibilities', {headers: getHeader()})
            .then(res=>{
                    this.banks = res.data.data.bank_eligibilities
                    this.is_loading_bank = false
                })
                .catch(e =>{
                    this.is_loading_bank = false
                    this.errorFunction(e)
                })
        },
				async getBankerListHandler(bank_code){
            this.is_loading_bank = true
						try{
								this.bankers = cloneDeep(this.userBankerList);
								this.bankers = await this.getBankersBasedOnBank(cloneDeep(this.userBankerList), bank_code, this.product.prod_type);
								let banker = this.bankers.find(bBank => bBank.id == this.form.banker_id)
                if(!banker){
                    this.form.banker_id = null
                }
								let selected_bank = this.banks.find(bank => bank.bank_code == bank_code)
								if(!_gHlp.isEmpty(selected_bank)){
                    this.form.bank_name = selected_bank.bank_name
                }

								this.is_loading_bank = false
            }catch(e){
								this.is_loading_bank = false
                _gNotif.errorFunction(e)
            }
        },
        async editProductDetail(){
            try{
                let cashback = this.product.product_detail.prod_pm_cashback;
                if (this.isApprovedBank) {
                    cashback = this.form.loan_amount - this.product.product_detail.prod_pm_net_buyer_discount
                }
                let data = {
                    "prod_agent_id": this.product.prod_agent_id,
                    "prod_agent_username" : this.product.prod_agent_username,
                    "prod_customer_basket" : this.product.prod_customer_basket,
                    "prod_customer_id" : this.product.prod_customer_id,
                    "prod_customer_name" : this.product.prod_customer_name,
                    "prod_type": this.product.prod_type,
                    "prod_loan_officer_id": this.form.prod_loan_officer_id,
                    "prod_main_status": this.product.prod_main_status,
                    "prod_status": this.product.prod_status,
                    "prod_loan_officer_id": this.form.prod_loan_officer_id,
                    "product_detail" : {
                        "prod_pm_project_name": this.product.product_detail.prod_pm_project_name,
                        "prod_pm_cashback": cashback
                    }
                }
                const res = await axios.post(services.product + 'product/' + this.product.prod_id, data, {headers: getHeader()})
								return _gHlp.getValue(res,'data',{});
            }catch(e){
                this.errorFunction(e)
            }
        },
        async editBank(){
            let bankData = {
                "prod_bnk_name": this.form.bank_name,
                "prod_bnk_prod_id": this.bank.prod_bnk_prod_id,
                "prod_bnk_logo_url": this.dsr_bank ? this.dsr_bank.bank_image_url : this.bank.prod_bnk_logo_url,
                "prod_bnk_banker_id": this.form.banker_id ?? null,
                "prod_bnk_stage_status": this.form.bank_status,
                "prod_bnk_loan_amount": this.form.loan_amount,
                "prod_bnk_spa_amount": this.form.spa_price,
                "prod_bnk_interest": this.form.interest,
                "prod_bnk_margin": this.form.margin_finance,
                "prod_bnk_tenure": this.form.tenure_years,
                "prod_bnk_gross_cashback": null,
                "prod_bnk_installment": this.form.installment,
                "prod_bnk_code": this.form.bank_code,
                "prod_bnk_submission_date": this.form.prod_bnk_submission_date,
                "prod_bnk_approved_date": this.form.approved_date,
                "prod_bnk_lo_sign_date": this.bank.prod_bnk_lo_sign_date,
                "prod_bnk_add_cost": this.form.prod_bnk_add_cost,
            }

            const res = await axios.post(services.product + 'product-bank/' + this.bank.prod_bnk_id, bankData, {headers: getHeader()})
            if(res.data && bankData.prod_bnk_banker_id && bankData.prod_bnk_banker_id != this.bank.prod_bnk_banker_id){
                this.createGroup(res.data);
            }
            if(this.product.product_detail.prod_pm_property_src != 'HESTIA') {
                const pmpRes = await this.syncV2CaseToPMP(this.product.prod_id)
            }
						return _gHlp.getValue(res,'data',{});
        },
        async editProduct(){
            try{
                this.is_loading_btn = true
                let bank = await this.editBank()
                let product = await this.editProductDetail()
								if(this.form.banker_id != this.bank.banker_id){
									this.sendEmailToBanker(bank,product)	
								}
                this.resetField()
								this.is_loading_btn = false
                this.$emit('update:show_edit_bank', false)
                caseEventBus.$emit('refresh-cases')
                this.notifySuccess('<b>Bank</b> - Successfully Updated.')
								this.checkGenerateCommission(this.product,'bank_statuses',this.form.bank_status)
            }catch(e){
                this.is_loading_btn = false
                this.errorFunction(e)
            }
        },
        resetField(){
            this.dsr_bank = null
        },
        async createGroup(data) {
            let bundle_key = this.getProfileBundleKey('banker', data);
            let profile = this.generateMessageProfile('banker', data, bundle_key, data.prod_bnk_updated_date);
            this.setMessageProfile(profile)
			const postData = {
				group_name:  this.product.prod_customer_name + " Application - Case iD " + this.product.prod_id,
				group_type: 'internal',
				group_channel_type: 'PUBLIC',
				group_bundle_key: this.getNewBundleKey(),
				group_participants: []
			}
			// Selected IDs and get all its objects
			const activeUser = _gAuth.activeUser()
			if (!_gHlp.isEmpty(activeUser)) {
				postData.group_participants.push({
					participant_user_id: activeUser.id,
					participant_username: activeUser.name,
					participant_fullname: activeUser.name,
					participant_photo_profile: null,
					gmp_is_admin: 1
				});
			}

			let adminUserIds = this.selectedAdminIds;
			this.selectedIds.forEach(selectedId => {
				const selectedUser = this.available_user_list.find(user => user.id == selectedId)
				if (selectedUser) {
					if (selectedUser.id != activeUser.id) {
						let isAdmin = adminUserIds.includes(selectedUser.id) ? 1 : 0;
						postData.group_participants.push({
							participant_user_id: selectedUser.id,
							participant_username: selectedUser.name,
							participant_fullname: selectedUser.name,
							participant_photo_profile: null,
							gmp_is_admin: isAdmin
						});
					}
				}
			});
			let status = await this.createGroupMessage(postData)
		},

        autoAddUser(){
			const excludeUsers = _gHlp.getValue(this.message_profile,'exclude_users',[]);
			const curDate = _gHlp.getCurrentDateTime();
			let tableData = _.cloneDeep(this.tableData);
			for (let i = 0; i < this.viewAbleUsers.length; i++) {
				const elUser = this.viewAbleUsers[i];
				if(_gHlp.isEmpty(excludeUsers) || !excludeUsers.includes(elUser.id)){
					tableData.push({
						id: elUser.id,
						name: elUser.name,
						join_date: curDate,
						is_admin: 0
					})
				}
			}
            this.selectedIds = this.tableData.map(o => o.id);
		},
        viewAbleUsers(){
			const userIds = !_gHlp.isEmpty(this.tableData) ? this.tableData.map(o => o.id) : [];
			userIds.push(_gAuth.activeUserId())

			let items = [];
			if(this.group_type == 'internal'){
				items = this.available_user_list.filter(o => (!userIds.includes(o.id) && (o.application_code == _gAuth.appCode()) && (!o.is_external_user)))
			}else{
				items = this.available_user_list.filter(o => !userIds.includes(o.id))
			}
			return items;
		},
    }
}
</script>
